import { JitsiConference, JitsiLocalTrack } from 'lib-jitsi-meet'

import { VideoCallUser } from '@tabeeb/modules/../users/types'

import { TracksState } from '../reducers/tracks'

export function getTrack(state: TracksState, userId: number, currentUserId: number, trackType: string) {
  let track = null
  if (userId === currentUserId) {
    track = state.localTracks.find((item) => item.getType() === trackType)
  } else {
    const tracks = state.remoteTracks[userId]
    track = tracks !== undefined ? tracks.find((item) => item.getType() === trackType) : null
  }
  return track
}

export function getAudioContainerById(userId: number) {
  const result = document.querySelectorAll<HTMLAudioElement>(`.tabeebUserAudio[data-id="${userId}"]`)
  return result.length !== 0 ? result[0] : null
}

export function getCallPreviewAudioContainerById(userId: number) {
  const result = document.querySelectorAll<HTMLAudioElement>(`.tabeebPreviewUserAudio[data-id="${userId}"]`)
  return result.length !== 0 ? result[0] : null
}

export function getVideoContainerById(userId: number) {
  const result = document.querySelectorAll<HTMLVideoElement>(`.tabeebUserVideo[data-id="${userId}"]`)
  return result.length !== 0 ? result[0] : null
}

export function getGridVideoContainerById(userId: number) {
  const result = document.querySelectorAll<HTMLVideoElement>(`.tabeebGridUserVideo[data-id="${userId}"]`)
  return result.length !== 0 ? result[0] : null
}

export function getCallPreviewVideoContainerById(userId: number) {
  const result = document.querySelectorAll<HTMLVideoElement>(`.tabeebPreviewUserVideo[data-id="${userId}"]`)
  return result.length !== 0 ? result[0] : null
}

export function getLargeVideoContainer() {
  const result = document.querySelectorAll<HTMLVideoElement>('.largeVideo')
  return result.length !== 0 ? result[0] : null
}

export function getPreviewVideoContainerById(deviceId: string) {
  const result = document.querySelectorAll<HTMLVideoElement>(`.tabeebUserVideo[data-id="${deviceId}"]`)
  return result.length !== 0 ? result[0] : null
}

export function isUnavailableForLargeVideo(largeVideoUser: VideoCallUser | null, isVideo: boolean, userId: number) {
  return (
    (largeVideoUser && !isVideo && largeVideoUser.id !== userId) || // if another user in large screen but current has no video
    (!largeVideoUser && !isVideo) // if current user has no video and large video is empty
  )
}

export function replaceTrack(jitsiRoom: JitsiConference, localVideo: JitsiLocalTrack, track: JitsiLocalTrack) {
  return jitsiRoom.replaceTrack(localVideo, track)
}
